import { useLoggedInUser } from "@/components/providers/ApiProvider/hooks";
import { hasActiveSession } from "@/lib/auth";
import { saveRedirect } from "@/lib/storage-utils";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { noindexHead } from "@/lib/seo";

export const Route = createFileRoute("/admin/_adminLayout")({
  component: AdminLayout,
  head: () => noindexHead("Admin | Lutely"),
  beforeLoad: async ({ location }) => {
    const isAuthenticated = await hasActiveSession();
    if (!isAuthenticated) {
      saveRedirect(location.href);
      throw redirect({
        to: "/",
        search: { auth: "login" as const },
      });
    }
  },
});

function AdminLayout() {
  const { isAdmin } = useLoggedInUser();

  if (!isAdmin) {
    return null;
  }

  return <Outlet />;
}
